import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-data-found',
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss']
})
export class NoDataFoundComponent implements OnInit {
  categoryHeaderId: string;
  requestProductView = {}
  constructor() { }

  ngOnInit(): void {
  }
  onCategoryFilterChange(categoryId: string) {
    this.categoryHeaderId = categoryId;
    this.requestProductView['categoryCode'] = categoryId
  }
  onBrandFilterChange(Brand: string) {
  }




  // Event handler for open filter change
  onOpenFilterChange(openFilterValue: string) {
  }
  onSearchFilterChange(searchFilterChange: string) {
  }
  oncontentSearchFilterChange(searchFilterChange: string) {
  }
}
